module.exports = __webpack_public_path__ + "static/media/032-cup.e7d2148b.svg";